import React from 'react';
import UserFormPage from './UserFormPage';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}

const UserNew: React.FC<ShowAlerts> = () => <UserFormPage mode="new" />;

export default UserNew;
